const MAX_COLUMNS = 12;
const MIN_COL_SPAN = 1;
const MAX_CELLS = 6;
const TRANSPARENT_COLOR = "#00000000";
const LAYOUT_DEFAULTS = {
  backgroundColor: "#00000000",
  backgroundImage: null,
  borderColor: "#00000000",
  borderWidth: 0,
  borderRadius: 0,
  backdropColor: null,
  backdropImage: null,
  backdropPaddingTop: 0,
  backdropPaddingBottom: 0,
  gap: 20,
  cellPadding: [18, 0, 18, 0],
  cellVerticalAlignment: "TOP",
  responsivenessBehaviour: "STACK",
  responsivenessBreakpoint: 400
};
const normalizePadding = (padding, defaults) => {
  if (!padding || padding.length === 0) {
    return defaults;
  }
  if (padding.length === 1) {
    return [padding[0], padding[0], padding[0], padding[0]];
  }
  if (padding.length === 2) {
    return [padding[0], padding[1], padding[0], padding[1]];
  }
  if (padding.length === 3) {
    return [padding[0], padding[1], padding[2], padding[1]];
  }
  return padding;
};
export {
  LAYOUT_DEFAULTS,
  MAX_CELLS,
  MAX_COLUMNS,
  MIN_COL_SPAN,
  TRANSPARENT_COLOR,
  normalizePadding
};
//# sourceMappingURL=shared-with-viewer.js.map
